import { Helmet } from 'react-helmet';

import { FailureTypesTable } from '../../components/Tables/Sigma/FailureTypesTable';

const FailureTypesPage = () => {
  return (
    <div className='table-module-container'>
      {/* Helmet sets the HTML <title> dynamically */}
      <Helmet>
        <title>Tipos de servicio</title>
      </Helmet>
      <div className='datatable'>
        {/* Render the FailureTypesTable component */}
        <FailureTypesTable />
      </div>
    </div>
  );
};

export default FailureTypesPage;
